import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {SepaDTO} from '../../../../DTOs';

@Component
export default class SepaForm extends Vue {
  @Prop({type: Boolean, default: false}) submittedPaymentFormProp!: boolean;
  @Prop() dto: SepaDTO | undefined;


  mounted() {
    this.$emit('submittedPaymentFormEmit', false);
  }

  showErrorClass(field: string): boolean {
    if (this.dto && this.submittedPaymentFormProp) {
      return !this.dto.validateField(field);
    }
    return false;
  }
}
